export default __webpack_public_path__ + "static/22_april_2021-204bc3cf0bb021b4d5ba32c072fa984f.png";